import { string } from 'prop-types';
import withSideEffect from 'react-side-effect';

function DocumentTitle({ children = null }) {
  return children;
}

DocumentTitle.propTypes = {
  title: string.isRequired,
};

function reducePropsToState(propsList) {
  const titles = propsList.map(({ title }) => title).reverse();
  return titles.join(' · ');
}

function handleStateChange(title) {
  document.title = title || 'Sales Cockpit';
}

export default withSideEffect(
  reducePropsToState,
  handleStateChange,
)(DocumentTitle);
